import classes from "./Modal.module.scss";

const Backdrop = (props) => {
  return (
    <div
      className={classes.backdrop}
      style={props.style}
      onClick={props.onClick}
    />
  );
};

const ModalOverlay = (props) => {
  return (
    <div className={props.className} style={{ height: "100%", ...props.style }}>
      <div
        className={classes.content}
        style={{ height: "100%", width: "100%" }}
      >
        {props.children}
      </div>
    </div>
  );
};

const Modal = (props) => {
  // NOW THIS WORKS SERVER SIDE
  return (
    <>
      <Backdrop style={props.styleBackdrop} onClick={props.onClose} />
      <ModalOverlay
        className={`${classes.modal_listingfulldisplay} ${props.className}`}
        style={props.styleModal}
      >
        {props.children}
      </ModalOverlay>
    </>
  );
};

export default Modal;
